import React from "react";

const RedeemIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66675 8.99997L10.0001 12.3333M10.0001 12.3333L13.3334 8.99997M10.0001 12.3333V4.66664C10.0001 3.50771 10.0001 2.92825 9.54132 2.27947C9.2365 1.8484 8.3589 1.31637 7.83573 1.24549C7.04832 1.1388 6.74931 1.29479 6.15127 1.60675C3.48619 2.997 1.66675 5.78601 1.66675 8.99997C1.66675 13.6023 5.39771 17.3333 10.0001 17.3333C14.6025 17.3333 18.3334 13.6023 18.3334 8.99997C18.3334 5.91546 16.6576 3.22236 14.1667 1.78149"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default RedeemIcon;
